var Navigation = require('./components/Navigation');

window.n = Navigation.create();



// WEBPACK FOOTER //
// ./src/scripts/index.js